export const CONTENT_KEY = 'content'
export const INCLUDE_UNAVAILABLE_PRODUCTS = 'include-unavailable'
export const PREVIEW = 'preview'
export const PRODUCT_DATA_KEY = 'product-data'
